import { createStore } from 'vuex';

import accounts from './modules/accounts';
import agentBots from './modules/agentBots';
import agentCapacityPolicies from './modules/agentCapacityPolicies';
import agents from './modules/agents';
import assignmentPolicies from './modules/assignmentPolicies';
import articles from './modules/helpCenterArticles';
import attributes from './modules/attributes';
import auditlogs from './modules/auditlogs';
import auth from './modules/auth';
import automations from './modules/automations';
import bulkActions from './modules/bulkActions';
import campaigns from './modules/campaigns';
import cannedResponse from './modules/cannedResponse';
import categories from './modules/helpCenterCategories';
import contactConversations from './modules/contactConversations';
import contactLabels from './modules/contactLabels';
import contactNotes from './modules/contactNotes';
import contacts from './modules/contacts';
import conversationLabels from './modules/conversationLabels';
import conversationMetadata from './modules/conversationMetadata';
import conversationPage from './modules/conversationPage';
import conversations from './modules/conversations';
import conversationSearch from './modules/conversationSearch';
import conversationStats from './modules/conversationStats';
import conversationTypingStatus from './modules/conversationTypingStatus';
import conversationWatchers from './modules/conversationWatchers';
import csat from './modules/csat';
import customRole from './modules/customRole';
import customViews from './modules/customViews';
import dashboardApps from './modules/dashboardApps';
// NOTICE: KAPTION-INTEGRATION - Dashboard app preloading
import dashboardAppPreload from './modules/dashboardAppPreload';
// NOTICE: KAPTION-INTEGRATION - Dashboard app badge notifications
import dashboardAppBadges from './modules/dashboardAppBadges';
import draftMessages from './modules/draftMessages';
import globalConfig from 'shared/store/globalConfig';
import aiStudio from './modules/aiStudio';
// NOTICE: KAPTION-INTEGRATION - usage-analytics.TOKEN.3 - analytics JWT cache
import usageAnalytics from './modules/usageAnalytics';
// NOTICE: KAPTION-INTEGRATION - Import Kaption Feature Flags module
import kaptionFeatureFlags from './modules/kaptionFeatureFlags';
// NOTICE: KAPTION-INTEGRATION - Feature Permissions (client-managed permission layer)
import featurePermissions from './modules/featurePermissions';
import inboxAssignableAgents from './modules/inboxAssignableAgents';
// NOTICE: KAPTION-INTEGRATION
import inboxAssignableAssistants from './modules/inboxAssignableAssistants';
import inboxes from './modules/inboxes';
import inboxMembers from './modules/inboxMembers';
import integrations from './modules/integrations';
import labels from './modules/labels';
import macros from './modules/macros';
import notifications from './modules/notifications';
// NOTICE: KAPTION-INTEGRATION - Device-level notification diagnostics.
import notificationSubscriptions from './modules/notificationSubscriptions';
import portals from './modules/helpCenterPortals';
import reports from './modules/reports';
import sla from './modules/sla';
import slaReports from './modules/SLAReports';
import summaryReports from './modules/summaryReports';
import teamMembers from './modules/teamMembers';
import teams from './modules/teams';
import userNotificationSettings from './modules/userNotificationSettings';
import webhooks from './modules/webhooks';
import captainAssistants from './captain/assistant';
import captainDocuments from './captain/document';
import captainResponses from './captain/response';
import captainInboxes from './captain/inboxes';
import captainBulkActions from './captain/bulkActions';
import copilotThreads from './captain/copilotThreads';
import copilotMessages from './captain/copilotMessages';
import captainScenarios from './captain/scenarios';
import captainTools from './captain/tools';

import kaptionAssistants from './modules/kaptionAssistants';
// NOTICE: KAPTION-INTEGRATION - Kaption Access Tokens
import kaptionAccessTokens from './modules/kaptionAccessTokens';
// NOTICE: KAPTION-INTEGRATION - Kaption Delivery Webhooks
import kaptionDeliveryWebhooks from './modules/kaptionDeliveryWebhooks';
// NOTICE: KAPTION-INTEGRATION - Kaption Response Policies
import kaptionResponsePolicies from './modules/kaptionResponsePolicies';
// NOTICE: KAPTION-INTEGRATION - smart-availability.UI.1 — queue-aware pickers
import kaptionSmartAvailability from './modules/kaptionSmartAvailability';
// NOTICE: KAPTION-INTEGRATION - WhatsApp Template Management
import whatsappTemplates from './modules/whatsappTemplates';

const plugins = [];

export default createStore({
  modules: {
    accounts,
    agentBots,
    agentCapacityPolicies,
    agents,
    assignmentPolicies,
    articles,
    attributes,
    auditlogs,
    auth,
    automations,
    bulkActions,
    campaigns,
    cannedResponse,
    categories,
    contactConversations,
    contactLabels,
    contactNotes,
    contacts,
    conversationLabels,
    conversationMetadata,
    conversationPage,
    conversations,
    conversationSearch,
    conversationStats,
    conversationTypingStatus,
    conversationWatchers,
    csat,
    customRole,
    customViews,
    dashboardApps,
    // NOTICE: KAPTION-INTEGRATION - Dashboard app preloading
    dashboardAppPreload,
    // NOTICE: KAPTION-INTEGRATION - Dashboard app badge notifications
    dashboardAppBadges,
    draftMessages,
    globalConfig,
    aiStudio,
    // NOTICE: KAPTION-INTEGRATION - usage-analytics.TOKEN.3 - analytics JWT cache
    usageAnalytics,
    // NOTICE: KAPTION-INTEGRATION - Register Kaption Feature Flags module
    kaptionFeatureFlags,
    // NOTICE: KAPTION-INTEGRATION - Register Feature Permissions module
    featurePermissions,
    inboxAssignableAgents,
    // NOTICE: KAPTION-INTEGRATION
    inboxAssignableAssistants,
    inboxes,
    // NOTICE: KAPTION-INTEGRATION
    kaptionAssistants,
    // NOTICE: KAPTION-INTEGRATION - Kaption Access Tokens
    kaptionAccessTokens,
    // NOTICE: KAPTION-INTEGRATION - Kaption Delivery Webhooks
    kaptionDeliveryWebhooks,
    // NOTICE: KAPTION-INTEGRATION - smart-availability.UI.1
    kaptionSmartAvailability,
    // NOTICE: KAPTION-INTEGRATION - Kaption Response Policies
    kaptionResponsePolicies,
    inboxMembers,
    integrations,
    labels,
    macros,
    notifications,
    // NOTICE: KAPTION-INTEGRATION - Register notification subscription diagnostics store.
    notificationSubscriptions,
    portals,
    reports,
    sla,
    slaReports,
    summaryReports,
    teamMembers,
    teams,
    userNotificationSettings,
    webhooks,
    captainAssistants,
    captainDocuments,
    captainResponses,
    captainInboxes,
    captainBulkActions,
    copilotThreads,
    copilotMessages,
    captainScenarios,
    captainTools,
    // NOTICE: KAPTION-INTEGRATION - WhatsApp Template Management
    whatsappTemplates,
  },
  plugins,
});
